// extracted by mini-css-extract-plugin
export default {"layoutRight":"TableRightTemplate_layoutRight__lQGqN","right":"TableRightTemplate_right__QdLe0","main":"TableRightTemplate_main__Umbb0"};